var transformProperty = function () {
    if (typeof window !== 'undefined') {
        var transform = window.document.documentElement.style.transform;
        if (typeof transform === 'string') {
            return 'transform';
        }
    }
    return 'WebkitTransform';
};
export default transformProperty();
